import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('../auth/auth.module').then((m) => m.AuthModule),

  },
  {
    path: 'home',
    loadChildren: () => import('../home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'beneficiaries',
    loadChildren: () =>
      import('../beneficiaries/beneficiaries.module').then(
        (m) => m.BeneficiariesModule,
      ),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'NOTARY', 'REFEREE'] },
  },
  {
    path: 'folders',
    loadChildren: () =>
      import('../folders/folders.module').then((m) => m.FoldersModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('../admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'REFEREE'] },
  },
  {
    path: 'stats',
    loadChildren: () =>
      import('../stats/stats.module').then((m) => m.StatsModule),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'CONSULTING_INT'] },
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: '/home' }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
